export const APP_ENTRY_FORM_NAME_FEES = "feeTabsForm";
export const APP_EDIT_FORM_NAME_FEES = "feesEditForm";
